export const es_locale = {
    months : 'Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Setptiembre,Octubre,Noviembre,Diciembre'.split(','),
    monthsShort : 'Ene._Fe._Mars_Abr._May_Jun_Jul._Agst_Sept._Oct._Nov._Dec.'.split(''),
    monthsParseExact : true,
    weekdays : 'Domingo,Lunes,Martes,Miercoles,Jueves,Viernes,Sabado'.split(','),
    weekdaysShort : 'dom._lun._mar._mir._jeu._ven._sab.'.split('_'),
    weekdaysMin : 'Do_Lu_Ma_Me_Ju_Vi_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    }
}